import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';
import View_Feedback_Preview from 'view/feedback_preview';
import {showAutoReplyMessage, deleteComment} from 'service/feedback';

export default View.extend({
    className: 'feedback-board-column',

    is_loaded: false,

    type: '',
    workflow_id: 0,
    priority: 'neutral',
    user_id: 0,

    name: '',
    colour: '',

    search_options: {},

    limit : 20,
    page  : 1,
    count : 0,

    views: {
        preview: null
    },

    events: {
        'click .column-settings .settings'  : 'onColumnSettings',
        'click .load-more'                  : 'onLoadMore',
        'click .refresh'                    : 'onRefresh',
        'mouseleave'                        : 'onMouseLeave'
    },

    dom_handlers: {
        onColumnSettings: function() {
            Modals.editWorkflow();
        },

        onLoadMore: function() {
            var total_pages = Math.ceil(this.count / this.limit);

            if (this.page < total_pages) {
                this.page++;
            }

            this.load(this.search_options, false);
        },

        onRefresh: function() {
            _.each(this.views.preview, function(view) {
                Cache.feedback.remove(view.model);
            });

            this.$el.find('.refresh i').addClass('fa-spin');

            this.load(this.search_options, true, () => {
                this.$el.find('.refresh i').removeClass('fa-spin');
            });
        },

        onMouseLeave: function() {
            this.$el.find('.column-settings .button-dropdown > div').hide();
        }
    },

    event_handlers: {
        onFeedbackAdd: function(model) {
            if (this.type === 'status' && model.get('workflow') !== this.workflow_id) {
                return;
            }

            if (this.type === 'priority' && model.get('priority') !== this.priority) {
                return;
            }

            if (this.type === 'assignee' && model.get('user_id') !== this.user_id) {
                return;
            }

            var is_injected = model.get('is_injected');

            var view = this.createFeedbackView(model, is_injected);

            if (is_injected) {
                this.count++;
                this.$el.find('.board-name .count').text(this.count);

                if (!this.$el.hasClass('.collapsed')) {
                    // scroll to the element
                    var top = view.el.offsetTop - this.$el.find('.scroller').get(0).offsetTop - 20; // 20px top margin

                    if (this.$el.find('.scroller').scrollTop() > top) {
                        this.$el.find('.scroller').scrollTop(top);
                    } else if ((this.$el.find('.scroller').scrollTop() + this.$el.find('.scroller').height()) < top) {
                        this.$el.find('.scroller').scrollTop(top);
                    }
                }
            }
        },

        onFeedbackRemove: function(model) {
            if (!this.views.preview['_' + model.id]) {
                return;
            }

            this.views.preview['_' + model.id].remove();
            delete this.views.preview['_' + model.id];

            this.count--;
            this.$el.find('.board-name .count').text(this.count);
        },

        onWorkflowChange: function(model) {
            if (this.type !== 'status') {
                return;
            }

            if (!this.views.preview['_' + model.id]) {
                return;
            }

            model.set('is_injected', true);
            Cache.feedback.remove(model);
            Cache.feedback.add(model);
            model.set('is_injected', false);
        },

        onPriorityChange: function(model) {
            if (this.type !== 'priority') {
                return;
            }

            if (!this.views.preview['_' + model.id]) {
                return;
            }

            model.set('is_injected', true);
            Cache.feedback.remove(model);
            Cache.feedback.add(model);
            model.set('is_injected', false);
        },

        onAssigneeChange: function(model) {
            if (this.type !== 'assignee') {
                return;
            }

            if (!this.views.preview['_' + model.id]) {
                return;
            }

            model.set('is_injected', true);
            Cache.feedback.remove(model);
            Cache.feedback.add(model);
            model.set('is_injected', false);
        }
    },

    initialize: function(options) {
        this.type           = options.type;
        this.workflow_id    = options.workflow_id;
        this.priority       = options.priority;
        this.user_id        = options.user_id;
        this.sort_type      = options.sort_type;
        this.sort_order     = options.sort_order;
        this.is_design      = options.is_design;
        this.is_open        = !!options.is_open;
        this.is_resolved    = !!options.is_resolved;
        this.include_merged = !!options.include_merged;

        this.views = {
            preview: {}
        };

        if (this.type === 'status') {
            var workflow_model = Cache.workflow.get(this.workflow_id);

            this.listenTo(workflow_model, 'change:name',   this.renderBoardName);
            this.listenTo(workflow_model, 'change:colour', this.renderBoardName);

            this.listenTo(Cache.feedback, 'change:workflow', this.event_handlers.onWorkflowChange);
        } else if (this.type === 'priority') {
            this.listenTo(Cache.feedback, 'change:priority', this.event_handlers.onPriorityChange);
        } else if (this.type === 'assignee') {
            this.listenTo(Cache.feedback, 'change:user_id', this.event_handlers.onAssigneeChange);
        }

        this.listenTo(Cache.feedback, 'add',    this.event_handlers.onFeedbackAdd);
        this.listenTo(Cache.feedback, 'remove', this.event_handlers.onFeedbackRemove);

        this.on('remove', () => {
            if (this.load_xhr) {
                this.load_xhr.abort();
            }
        });
    },

    makeDroppable: function() {
        this.$el.droppable({
            addClasses: false,
            accept: '.feedback-preview',
            drop: function(e, ui) {
                var feedback_id = ui.helper.data('feedback_id');
                var feedback_model = Cache.feedback.get(feedback_id);

                var xhr_action;
                var xhr_data;
                var new_model_attr;

                switch (this.type) {
                    case 'status':
                        new_model_attr = {
                            workflow: this.workflow_id
                        };

                        xhr_action = 'feedback/setWorkflow';
                        xhr_data = {
                            ids      : [feedback_id],
                            workflow : this.workflow_id,
                            send_autoreply: true
                        };

                        break;
                    case 'priority':
                        new_model_attr = {
                            priority: this.priority
                        };

                        xhr_action = 'feedback/setPriority';
                        xhr_data = {
                            ids      : [feedback_id],
                            priority : this.priority
                        };

                        break;
                    case 'assignee':
                        new_model_attr = {
                            user_id: this.user_id
                        };

                        xhr_action = 'feedback/setUser';
                        xhr_data = {
                            ids     : [feedback_id],
                            user_id : this.user_id
                        };

                        break;
                }

                // remove then add, so that
                // 1. the model is added with the respect of sort by
                // 2. the view is removed from the old column and created in the new column
                Cache.feedback.remove(feedback_model);

                feedback_model.set(_.extend({
                    last_update_time : Math.floor((new Date()).getTime() / 1000),
                    is_injected      : true
                }, new_model_attr));

                Cache.feedback.add(feedback_model);
                feedback_model.set('is_injected', false);

                Cache.app.request({
                    action: xhr_action,
                    context: this,
                    data: xhr_data,
                    success: function(result) {
                        if (this.type === 'status') {
                            if (!result || !result.autoreply_comments || result.autoreply_comments.length === 0) {
                                return;
                            }
                            const comment_ids = result.autoreply_comments.map((comment) => comment.id);
                            showAutoReplyMessage(() => {
                                deleteComment(comment_ids);
                            });

                            // loop through the autoreply comments and add them to the cache
                            result.autoreply_comments.forEach((autoreply_comment) => {
                                if (!Cache.feedback_comment.get(autoreply_comment.id)) {
                                    Cache.feedback_comment.add(autoreply_comment);
                                }
                            });
                        }
                    }
                });

            }.bind(this)
        });
    },

    makeDraggable: function(view) {
        var view_el = view.$el;

        var sroller = $('.feedback-board-container > div');
        var window_width = $(window).width();
        var scroller_left = sroller.offset().left;

        var prev_helper_offset_left = null;

        view_el.draggable({
            addClasses: false,
            helper: 'clone',
            revert: 'invalid',
            distance: 5,
            scroll: false,
            appendTo: document.body,
            drag: function(e, ui) {
                var helper_pos_right = ui.offset.left + ui.helper.outerWidth();
                var helper_pos_left  = ui.offset.left;

                if (prev_helper_offset_left === null) {
                    prev_helper_offset_left = helper_pos_left;
                }

                if (helper_pos_left >= prev_helper_offset_left) {
                    ui.helper.attr('data-direction', 'right');
                } else {
                    ui.helper.attr('data-direction', 'left');
                }

                if (Math.abs(helper_pos_left - prev_helper_offset_left) >= 80) {
                    prev_helper_offset_left = helper_pos_left;
                }

                if (helper_pos_right > window_width) {
                    // scroll right
                    sroller.scrollLeft(sroller.scrollLeft() + (helper_pos_right - window_width) / 2);
                } else if (helper_pos_left < scroller_left) {
                    // scroll left
                    sroller.scrollLeft(sroller.scrollLeft() - (scroller_left - helper_pos_left) / 2);
                }
            },
            start: (e, ui) => {
                // store column container in a variable because it changes
                this.draggable_start = view_el.parents('.feedback-board-column');
                this.draggable_start.droppable('disable');

                view_el.addClass('disabled');

                ui.helper.data('feedback_id', view.model.id);

                $(document.body).addClass('ui-dragging');

                ui.helper.css({
                    'width'            : view_el.outerWidth(),
                    'transform-origin' : e.offsetX + 'px ' + e.offsetY + 'px'
                });
            },
            stop: (e, ui) => {
                this.draggable_start.droppable('enable');

                view_el.removeClass('disabled');

                $(document.body).removeClass('ui-dragging');

            }
        });
    },

    createFeedbackView: function(model, is_injected) {
        var new_view = this.views.preview['_' + model.id] = new View_Feedback_Preview({
            model: model,
            groupby: this.type,
            view_type: function() {
                return 'column';
            }
        });

        new_view.render();
        this.makeDraggable(new_view);

        var view_container = this.$el.find('.scroller > div');
        var view_elememnt  = new_view.$el;

        // when a new feedback is injected after the list is built
        if (is_injected) {
            var new_model_index = Cache.feedback.indexOf(model);
            var all_keys = _.keys(this.views.preview);

            if (_.size(this.views.preview) === 0) {
                view_elememnt.appendTo(view_container);
            } else if (_.size(this.views.preview) === 1) {
                if (new_model_index < Cache.feedback.indexOf(this.views.preview[all_keys[0]].model)) {
                    view_elememnt.prependTo(view_container);
                } else {
                    view_elememnt.appendTo(view_container);
                }
            } else {
                if (new_model_index < Cache.feedback.indexOf(this.views.preview[all_keys[0]].model)) {
                    // top
                    view_elememnt.prependTo(view_container);
                } else if (new_model_index > Cache.feedback.indexOf(this.views.preview[all_keys[all_keys.length - 1]].model)) {
                    // bottom
                    view_elememnt.appendTo(view_container);
                } else {
                    // inject in between
                    var added = false;
                    _.each(this.views.preview, function(view) {
                        var collection_index = Cache.feedback.indexOf(view.model);

                        if (!added && new_model_index < collection_index) {
                            view_elememnt.insertBefore(view.$el);
                            added = true;
                        }
                    });

                    if (!added) {
                        view_elememnt.appendTo(view_container);
                    }
                }
            }

            new_view.pulse();
        } else {
            view_elememnt.appendTo(view_container);
        }

        return new_view;
    },

    getSearchParams: function() {
        var search_params = {
            sort_type  : this.sort_type,
            sort_order : this.sort_order
        };

        switch (this.type) {
            case 'status':
                search_params.workflow = [this.workflow_id];
                break;
            case 'priority':
                search_params.priority = [this.priority];
                break;
            case 'assignee':
                search_params.assignee = [this.user_id];
                break;
        }

        return _.extend({}, this.search_options, search_params);
    },

    load: function(search_options, reset, on_complete) {
        if (['status', 'priority', 'assignee'].indexOf(this.type) === -1) {
            return;
        }

        if (this.type === 'status') {
            delete search_options.exclude_resolved;
        }

        this.$el.addClass('loading');

        this.sort_type  = search_options.sort_type  || this.sort_type;
        this.sort_order = search_options.sort_order || this.sort_order;

        this.search_options = _.extend({}, search_options);
        this.search_options = _.extend(this.search_options, this.getSearchParams());

        if (reset) {
            this.page = 1;
        }

        this.load_xhr = Cache.app.request({
            action: 'feedback/search',
            data: _.extend({
                page           : this.page,
                limit          : this.limit,
                sort_type      : this.sort_type,
                sort_order     : this.sort_order,
                type           : this.is_design ? 'design' : 'web',
                include_merged : this.include_merged
            }, this.search_options),
            success: (response) => {
                Cache.feedback.setSortBy(this.sort_type, this.sort_order);

                Cache.feedback_comment.add(response.feedback_comment);
                Cache.feedback_screenshot.add(response.feedback_screenshot);
                Cache.feedback_approver.add(response.feedback_approver);
                Cache.feedback.add(response.feedback);
                Cache.feedback_watch_list.add(response.feedback_watch_list);

                this.count = response.count;

                this.$el.find('.board-name .count').text(this.count);
                this.$el.find('.load-more').toggle(this.count > _.size(this.views.preview));
            },
            complete: () => {
                this.load_xhr = null;
                this.is_loaded = true;

                this.$el.removeClass('loading');

                if (on_complete) {
                    on_complete();
                }

                this.trigger('search_complete', {
                    is_loaded: true
                });
            }
        });
    },

    renderBoardName: function() {
        var colour = '';
        var name   = '';
        var avatar = '';

        if (this.type === 'status') {
            colour = Cache.workflow.get(this.workflow_id).get('colour');
            name   = Cache.workflow.get(this.workflow_id).get('name');
        } else if (this.type === 'priority') {
            var colour_options = {
                urgent  : '#E80000',
                high    : '#F0A028',
                neutral : '#2878F0',
                low     : '#8090A0',
            };

            colour = colour_options[this.priority] || '';
            name   = Util.cap(this.priority);
        } else if (this.type === 'assignee') {
            if (this.user_id === 0) {
                name   = 'Unassigned';
                avatar = '<img class="user-24" src="/image/profile.png">';
            } else {
                name   = Cache.user.get(this.user_id) ? Cache.user.get(this.user_id).get('name') : '';
                avatar = Cache.user.get(this.user_id) ? '<img class="user-24" src="' + Cache.user.get(this.user_id).getAvatar() + '">' : '';
            }
        }

        var content = '';

        content +=
        (this.type === 'status' && !this.is_resolved ?
        '<span class="workflow-option-colour" style="background-color:' + colour + ';"></span>' : '') +
        (this.type === 'status' && this.is_resolved ?
        '<span class="workflow-option-resolved" style="color:' + colour + ';"><i class="fas fa-check-circle"></i></span>' : '') +

        avatar +
        '<span class="name">' + Util.htmlEntities(name) + '</span>' +
        '<span class="count">' + this.count + '</span>';

        this.$el.find('.board-name').html(content);
    },

    render: function() {
        var content = '';

        content += '<div class="drop-shadow"></div>';

        content += '<div class="column-settings">' +
                        '<button type="button" class="refresh small round square tooltip" data-title="Refresh"><i class="fas fa-sync-alt"></i></button>' +
                        (Cache.app.isAdmin() && this.type === 'status' ?
                        '<button type="button" class="settings small round square tooltip" data-title="Edit Status"><i class="fas fa-cog"></i></button>' : '') +
                    '</div>';

        content += '<div class="board-name"></div>';

        content += '<div class="scroller">' +
                        '<div></div>' +
                        '<button type="button" class="load-more">Load more <i class="far fa-angle-down"></i></buton>' +
                    '</div>';

        this.$el.html(content);

        this.renderBoardName();
        this.makeDroppable();

        var column_settings = Cache.app.getUserSetting('board_columns_collapsed', true);

        if (column_settings) {
            column_settings = JSON.parse(column_settings);
        }

        if (column_settings && Array.isArray(column_settings[this.type])) {
            var column_name;
            switch (this.type) {
                case 'status':
                    column_name = this.workflow_id;
                    break;
                case 'priority':
                    column_name = this.priority;
                    break;
                case 'assignee':
                    column_name = this.user_id;
                    break;
            }

            if (column_settings[this.type].indexOf(column_name) !== -1) {
                this.$el.addClass('collapsed');
            }
        }

        return this;
    }
});